module.exports = function() {
  return new Worker(__webpack_public_path__ + "static/workers/worker.35dc0e7935c23d51acaa.js");
};